import type { LoadedVault, } from "@bracket/platform/types";
import { DateTime, Interval, } from "luxon";
import { getBlockRewardsAPY, } from "./getBlockRewardsAPY";
import { WEI, } from "@bracket/blocksmith";
import { getDateTime, } from "@bracket/parlance";


/**
 * Resolve the Vault APY for a given vault.
 * @param {ShortLoadedVault} vault the vault subject for this APY resolution.
 * @returns {Promise<number>} the APY for the vault. 
 */
export const getVaultAPY = async ( vault:LoadedVault ): Promise<number> => {

	// return get7dApy(vault);
	try {

		const {
			launch_date,
			estimated_performance,
			nav: {
				epoch,
				nav,
				updated,
			},
			denomination,
			denomination: {
				symbol,
			}
		} = vault;

		if(epoch <= 1) {
			return estimated_performance || 0;
		}

		// const daysSinceLaunchA = Interval.fromDateTimes(DateTime.fromISO(launch_date).plus({ hours: epoch_offset_hours, }), DateTime.fromISO(updated.toString()), ).length("days");
		// const avaultOnlyAPY = ((Number(nav)/(10**decimals)) ** (365/daysSinceLaunch)) - 1;

		const daysSinceLaunch = getDateTime(updated).diff(getDateTime(launch_date), "days").days;
		const vaultOnlyAPY = WEI.fromSync(nav, denomination).pow(365/daysSinceLaunch).subtract(1).toNumber();

		const vaultAPY = symbol === "BRKTETH"
			? (1+vaultOnlyAPY) * (1+await getBlockRewardsAPY()) - 1
			: vaultOnlyAPY;

		const result = vaultAPY * 100;
		return result;

	} catch (error) {

		console.error("failed to get vault apy", error);
		return 0;

	}

}


export const get7dApy = async ( vault:LoadedVault ): Promise<number> => {


	try {

		const {
			estimated_performance,
			epoch_duration_days,
			symbol: vaultSymbol,
			nav: {
				epoch,
			},
			navs,
			denomination: {
				decimals,
			}
		} = vault;

		if(epoch <= 1) {
			return estimated_performance || 0;
		}

		if(vaultSymbol === "BBOR1" || epoch_duration_days !==1 || navs.length < 14) {
			return -100;
		}

		const sortedNavs = navs.sort((a, b) => a.epoch - b.epoch);
		const d7Nav = sortedNavs[sortedNavs.length - 15];
		const lastNav = sortedNavs[sortedNavs.length - 1];
		const navdif = BigInt(lastNav.nav) - BigInt(d7Nav.nav) + BigInt(10**decimals);
		const vaultOnlyAPY = ((Number(navdif)/(10**decimals)) ** 26) - 1;
		return vaultOnlyAPY * 100;

	}
	catch(error) {

		console.error("failed to get vault 7d apy", error);
		return 0;
	}

}
